import { CIcon } from '~/icons/types'

export const ciAuditRequest: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm22.09 19.124-2.429-2.047a6.389 6.389 0 0 0 .465-2.388 6.443 6.443 0 0 0-3.389-5.668 3.584 3.584 0 0 0-.762-2.075c.205-.21.336-.485.336-.798 0-.667-.562-1.19-1.278-1.19h-.365l-.871-2.065a2.54 2.54 0 0 0-2.375-1.632l-4.75.006c-.982-.12-1.999.5-2.546 1.597l-.882 2.094H2.88c-.717 0-1.278.523-1.278 1.19 0 .33.139.625.365.838a3.482 3.482 0 0 0-.717 2.158v2.202c0 .264.138.499.352.633v1.714c0 .866.67 1.57 1.493 1.57H4.25c.823 0 1.493-.704 1.493-1.57v-.806h1.768a6.412 6.412 0 0 0-.261 1.8 6.445 6.445 0 0 0 6.438 6.439 6.39 6.39 0 0 0 3.4-.981l2.078 1.994c.41.408.947.612 1.485.612.538 0 1.076-.204 1.486-.613.817-.82.817-2.152-.047-3.014ZM5.488 3.49c.231-.462.663-.784 1.09-.73h4.843c.419 0 .828.276.981.686l1.009 2.395H4.5l.988-2.351ZM3.102 13.693v-1.308l1.142.278.006 1.1-1.148-.07Zm2.246-2.305-2.598-.632V9.98h1.363a.75.75 0 0 0 0-1.5H2.857c.103-.33.292-.67.668-.952l.235-.188h10.48l.215.17c.295.254.506.566.639.899a6.4 6.4 0 0 0-1.407-.16 6.435 6.435 0 0 0-5.524 3.149v-.012H5.348Zm3.402 3.3a4.943 4.943 0 0 1 4.938-4.937 4.943 4.943 0 0 1 4.938 4.938 4.943 4.943 0 0 1-4.938 4.938 4.944 4.944 0 0 1-4.938-4.938Zm12.326 6.388a.606.606 0 0 1-.86-.01L18.271 19.2c.239-.242.456-.506.654-.783l2.15 1.81a.599.599 0 0 1 .001.848Z',
      fill: 'currentColor'
    },
    {
      d:
        'm14.924 13.021-1.922 2.307-.924-1.117a.751.751 0 0 0-1.156.957l1.5 1.812a.75.75 0 0 0 .577.271H13a.748.748 0 0 0 .576-.27l2.5-3a.75.75 0 1 0-1.152-.96Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'audit-request',
  type: 'light',
  fill: 'none'
}
